import type { CtCsvRow } from './types';

const identifierCollator = new Intl.Collator('en', { numeric: true });

/** Match the numeric assay/sample ordering used by sorted Takara exports. */
export const compareCtsIdentifiers = (a: string, b: string): number => identifierCollator.compare(a, b);

/** Presentation order is independent of insertion IDs; keep the original rows and well identities intact. */
export function sortCtsRows<T extends Pick<CtCsvRow, 'assay' | 'sample' | 'row' | 'column'>>(rows: readonly T[]): T[] {
  return [...rows].sort(
    (a, b) =>
      compareCtsIdentifiers(a.assay, b.assay) ||
      compareCtsIdentifiers(a.sample, b.sample) ||
      a.row - b.row ||
      a.column - b.column,
  );
}
